module.exports = __webpack_public_path__ + "img/candidates.ba600bac.svg";